import { gql } from "@apollo/client";

export default gql`
query getGoogleMapKey($platFormWeb: platform!) {
    getGoogleMapKey(PlatFormWeb: $platFormWeb)
  }
`;
